import { render, staticRenderFns } from "./directHeading.vue?vue&type=template&id=5b1faf4e&scoped=true"
import script from "./directHeading.vue?vue&type=script&lang=js"
export * from "./directHeading.vue?vue&type=script&lang=js"
import style0 from "./directHeading.vue?vue&type=style&index=0&id=5b1faf4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1faf4e",
  null
  
)

export default component.exports